import { render, staticRenderFns } from "./QDialog.vue?vue&type=template&id=65152841&scoped=true&"
import script from "./QDialog.vue?vue&type=script&lang=js&"
export * from "./QDialog.vue?vue&type=script&lang=js&"
import style0 from "./QDialog.vue?vue&type=style&index=0&id=65152841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65152841",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/app_data/product_data/deploy-center/s3-deploy/uqp/embedded.profile.acgn/v1.1.2-20210730-175657/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VCard,VDialog,VList,VListTile,VListTileContent,VListTileTitle})
